import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-printchallan',
  templateUrl: './printchallan.component.html',
  styleUrls: ['./printchallan.component.scss']
})
export class PrintchallanComponent {
  issuedate: any;
  challandata: any;
  amount: [] = [];
  price: number = 0;
  amounts: any[] = [];
  vitarandate: any;
  names: any;

  close() {
    this.dialogref.close();
  }

  constructor(
    private dialogref: MatDialogRef<PrintchallanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private router: Router,
    private service: DigisubservicesService
  ) {}

  ngOnInit() {
    this.issuedate   = this.data['issuedate'];
    this.amount      = this.data['amount'];
    this.names       = this.data['names'];
    this.vitarandate = this.data['vitarandate'];
    this.runapi();
  }

  // runapi() {
  //   const stringArray = this.amount.map((num: any) => num.toString());
  //   const req = {
  //     issuedate: this.issuedate,
  //     value: stringArray,
  //     name: this.names
  //   };

  //   this.service.challandata(req).subscribe((data: any) => {
  //     this.challandata = data;
  //     this.price = Number(this.challandata.pricing[0]['price']);
  //     this.amounts = [];

  //     this.amount.forEach((element: any, index: number) => {
  //       if (index < this.challandata.rep_add.length) {
  //         this.amounts.push({
  //           amount:  Number(element),
  //           address: this.challandata.rep_add[index].address,
  //           pincode: this.challandata.rep_add[index].pincode,
  //           name:    this.challandata.rep_add[index].issueSellerName,
  //           taluka:  this.challandata.rep_add[index].taluka,
  //           mobile:  this.challandata.rep_add[index].mobile_no,
  //         });
  //       }
  //     });
  //   });
  // }

 runapi() {
  const stringArray = this.amount.map((num: any) => num.toString());
  const req = {
    issuedate: this.issuedate,
    value: stringArray,
    name: this.names
  };

  this.service.challandata(req).subscribe((data: any) => {
    this.challandata = data;
    this.price = Number(this.challandata.pricing[0]['price']);
    this.amounts = [];

    this.challandata.rep_add.forEach((rep: any) => {
      this.amounts.push({
        amount:  Number(rep.amount),  // ✅ amount now comes from API, already matched
        address: rep.address,
        pincode: rep.pincode,
        name:    rep.issueSellerName,
        taluka:  rep.taluka,
        mobile:  rep.mobile_no,
      });
    });

    console.log('Total challans:', this.amounts.length);
    console.log('Amounts:', this.amounts);
  });
}

printNow() {
  const price       = this.price;
  const vitarandate = this.vitarandate;
  const amounts     = this.amounts;

  const challans = amounts.map((data: any) => `
    <div class="challan-box">

      <!-- HEADER: Org LEFT | Logo RIGHT -->
      <div class="challan-header">
        <div class="org-info">
          <p class="org-name">हिंदुस्थान प्रकाशन संस्था</p>
          <p class="org-address">116-119, शिल्पीन सेंटर, पहिला मजला, गं. द. आंबेकर मार्ग, वडाळा, मुंबई - 400 031 दूरध्वनी : 9967570531</p>
        </div>
        <div class="logo-area">
          <img src="assets/img/brand/red.png" alt="Vivek Logo" width="90">
        </div>
      </div>

      <!-- ADDRESS + DATE ROW -->
      <div class="address-row">
        <div class="address-block">
          <p>प्रति ,</p>
          <p><strong>${data.name}</strong></p>
          <p>${data.address}</p>
          <p>${data.pincode} ${data.taluka}</p>
          <p>${data.mobile}</p>
        </div>
        <div class="date-block">
          <p>दिनांक</p>
          <p>${vitarandate}</p>
        </div>
      </div>

      <!-- TABLE (centered) -->
      <div class="table-wrapper">
        <table class="challan-table">
          <thead>
            <tr>
              <th>अंक संख्या</th>
              <th>रक्कम</th>
              <th>गणीबंडल</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>${data.amount}</td>
              <td>${data.amount * price}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- SIGNOFF -->
      <div class="signoff">
        <p>(वर्गणी व विक्री विभाग)</p>
      </div>

      <!-- FOOTER -->
      <div class="challan-footer">
        <p><strong>मुख्य कार्यालय :</strong> 12, कामत औद्योगिक वसाहत, 316, स्वा. वीर सावरकर मार्ग, प्रभादेवी, मुंबई - 400025</p>
        <p>E-mail : vivekwklvargani@gmail.com &nbsp;•&nbsp; Website : www.vivek.com</p>
      </div>

    </div>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Challan Print</title>
      <style>
        @page {
          size: A4 landscape;
          margin: 8mm;
        }

        * { box-sizing: border-box; margin: 0; padding: 0; }

        body {
          font-family: 'Noto Sans Devanagari', 'Mangal', Arial, sans-serif;
          font-size: 12px;
          background: #fff;
          color: #000;
        }

        /* ── Page: two challans side by side ── */
        .challan-page {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
        }

        /* ── Single challan box ── */
        .challan-box {
          width: 50%;
          padding: 8mm 10mm;
          border: 1px solid #aaa;
          min-height: 190mm;
          display: flex;
          flex-direction: column;
          page-break-inside: avoid;
        }

       /* ── HEADER ── */
.challan-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #000;
  padding-bottom: 6px;
  margin-bottom: 12px;
  width: 100%;
}

.org-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;   /* pushes name to right side, just before logo */
  text-align: left;        /* address text itself is left-aligned */
}

.org-name {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
  align-self: flex-end;    /* name floats to the right */
  text-align: right;
}

.org-address {
  text-align: left;        /* address stays left */
  font-size: 11.5px;
  line-height: 1.6;
  align-self: flex-start;  /* address anchors to the left */
}

.logo-area {
  flex-shrink: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.logo-area img {
  display: block;
  height: 100px;
  margin-top: -15px;
}

        /* ── ADDRESS ROW ── */
        .address-row {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          margin-bottom: 8px;
        }

        .address-block {
          flex: 1;
        }

        .address-block p {
          margin: 3px 0;
          line-height: 1.6;
        }

        .date-block {
          flex-shrink: 0;
          text-align: right;
          white-space: nowrap;
          padding-left: 10px;
        }

        .date-block p {
          margin: 3px 0;
          line-height: 1.6;
        }

        /* ── TABLE WRAPPER: centers the table ── */
        .table-wrapper {
          flex: 1;
          display: flex;
          align-items: center;       /* vertical center in remaining space */
          justify-content: center;   /* horizontal center */
          padding: 10mm 0;
        }

        /* ── TABLE ── */
        .challan-table {
          width: 80%;                /* not full width so it looks centered */
          border-collapse: collapse;
        }

        .challan-table th,
        .challan-table td {
          border: 1px solid #000;
          text-align: center;
          padding: 10px 6px;
          font-size: 12px;
        }

        .challan-table thead tr {
          background-color: #f0f0f0;
        }

        .challan-table th {
          font-weight: bold;
        }

        .challan-table td {
          height: 40px;
          vertical-align: middle;
        }

        /* ── SIGNOFF ── */
        .signoff {
          text-align: right;
          border-bottom: 1px solid #000;
          padding: 6px 20px 6px 0;
          margin-bottom: 6px;
        }

        .signoff p { margin: 0; }

        /* ── FOOTER ── */
        .challan-footer {
          text-align: center;
          font-size: 10.5px;
          margin-top: 4px;
        }

        .challan-footer p {
          margin: 3px 0;
          line-height: 1.5;
        }
      </style>
    </head>
    <body>
      <div class="challan-page">
        ${challans}
      </div>
    </body>
    </html>
  `;

  const win = window.open('', '_blank', 'width=1123,height=794');
  if (win) {
    win.document.open();
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
      win.close();
    }, 600);
  }
}
}